import { Link } from 'react-router-dom';
import { ChartLine, Info, Tag } from '@phosphor-icons/react';

const ACTION_ICONS = {
  default: Tag,
  reports: ChartLine,
  info: Info,
};

/**
 * `ds/nav/top-bar--mobile--title` — modo "tab" do topo mobile (rotas da bottom
 * bar): altura 56, título $type-display-stat à esquerda e acção opcional
 * (ícone 16 + label $type-label) à direita. Sem acção, o slot desaparece.
 */
export function MobileTabHeader({ title, actionTo, actionLabel, actionIcon = 'default' }) {
  const ActionIcon = ACTION_ICONS[actionIcon] || ACTION_ICONS.default;

  return (
    <header className="fixed inset-x-0 top-0 z-30 flex h-14 items-center justify-between gap-space-3 border-b border-border bg-card px-space-4">
      <h1 className="min-w-0 flex-1 truncate font-display text-type-display-stat font-semibold tracking-tight text-foreground">
        {title}
      </h1>
      {actionTo && actionLabel ? (
        <Link
          to={actionTo}
          className="flex shrink-0 items-center gap-space-1 text-type-label font-semibold text-sage-on-tint hover:underline"
        >
          <ActionIcon className="h-4 w-4 shrink-0" aria-hidden />
          {actionLabel}
        </Link>
      ) : null}
    </header>
  );
}
